import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ReactPlayer from 'react-player';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './style.css';
import MainHeading from '../../GlobalComponents/Utils/mainHeading';
import alJazeeraLogo from '../../Assets/logos/aljazeera.png';
import img1 from "../../Assets/recent-projects/recent-1.jpeg";
import img2 from "../../Assets/recent-projects/recent-2.jpg";
import img3 from "../../Assets/recent-projects/recent-3.jpg";
import img4 from "../../Assets/recent-projects/recent-4.jpeg";
import PlayIcon from '../../GlobalComponents/Play-button-1';
import { Autoplay, Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';


export default function RecentProjects() {
    const { t ,i18n} = useTranslation();
   const translatedItems = useMemo(() => {
  const rawItems = t('projects.items', { returnObjects: true });
  return Array.isArray(rawItems) ? rawItems : Object.values(rawItems);
}, [t, i18n.language]);

console.log("Language:", i18n.language);
console.log("Translated items:", translatedItems);



    const swiperRef = useRef(null); // Create a ref to access Swiper instance
    const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
    const [videoUrl, setVideoUrl] = useState('');
    const [playing, setPlaying] = useState(false);
  

    const storiesData = [
        {
            logo: alJazeeraLogo,bg: img1, vimeoId: '737099444'
        },
        {
            logo: alJazeeraLogo,bg: img2,vimeoId: '489755949'
        },
        {
            logo: alJazeeraLogo,bg: img3, vimeoId: '225090240'
        },
        {
            logo: alJazeeraLogo,bg: img4,vimeoId: '737117181'
        },
    ];
    const mappedStories = (translatedItems || []).map((item, index) => ({
    ...item,
    ...(storiesData[index] || {}) // Prevent crash if index is out of bounds
}));


    const handleVideoPlay = (vimeoId) => {
        setVideoUrl(`https://vimeo.com/${vimeoId}`);
        setIsModalOpen(true);
        setPlaying(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVideoUrl('');
        setPlaying(false);
    };

    const handleMouseEnter = () => {
        swiperRef.current.swiper.autoplay.stop();
    };

    const handleMouseLeave = () => {
        swiperRef.current.swiper.autoplay.start();
    };

    return (
        <div className='mySlider'>
            <MainHeading
  align={'center'}
  flexDirection={'row'}
  gap={'10px'}
  width={'95%'}
  content1={t("projects.title").split(" ")[0] + " "}
  content2={t("projects.title").split(" ")[1]}
/>

            <p className='section_slogan'>
  {t("projects.description")}
</p>

            <Swiper
                key={i18n.language}
                ref={swiperRef}
                spaceBetween={5}
                slidesPerView={1.6}
                initialSlide={1}
                loop={true}
                centeredSlides={true}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                modules={[Pagination, Autoplay]}
                
                className="mySwiper2"
            >
                {mappedStories.map((item, index) => (
                    <SwiperSlide
                        key={index}
                        style={{ backgroundImage: `url(${item.bg})` }}
                        className='recentProjectsInnerSlider'
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <div className='playButton'>
                            <PlayIcon height={"60px"} width={"60px"} onClick={() => handleVideoPlay(item.vimeoId)} />
                        </div>
                        <div className='title_subtitle'>
                            <h1>{item.title}</h1>
                            <h3>{item.sub_title}</h3>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className={`videoModal ${isModalOpen ? 'show-vimeo-video' : ''}`}>
                <div className="videoContainer">
                    <ReactPlayer
                        url={videoUrl}
                        playing={playing}
                        controls={true}
                        width="100%"
                        height="100%"
                    />
                    <button className="closeButton" onClick={closeModal}>X</button>
                </div>
            </div>
        </div>
    );
}
